import { render, staticRenderFns } from "./PracticeUpcomingBookings.vue?vue&type=template&id=1cd4fb21&"
import script from "./PracticeUpcomingBookings.vue?vue&type=script&lang=js&"
export * from "./PracticeUpcomingBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports